<div class="allcolorfils">
    <div class="half-colorfils colorfils-rline" >
        <div class="quntty-row">
            <div class="quntty-row">
                <div class="quntty-numb center-items">{{this.numberAccessories}}</div>
                <div class="quntty-mandp center-items" (click)="this.numAccessories(-1)">-</div>
                <div class="quntty-mandp center-items" (click)="this.numAccessories(1)">+</div>
            </div>
        </div>
    </div>
</div>